module.exports = __webpack_public_path__ + "founders-5fefe56edb4b7a0702ac182c9ffc0cf3.webp";